import styled from 'styled-components';

export const Card = styled.div`
${(p) => p.card1 && `
background-color: #151a1c;
`};
${(p) => p.card2 && `
background-color: #151a1c;
`};
${(p) => p.card3 &&`
background-color: #151a1c;
`};
${(p) => p.card4 && `
background-color: #151a1c;
`};
${(p) => p.card5 && `
background-color: #151a1c;
`};
${(p) => p.card6 && `
background-color: #151a1c;
`};
background-position:center;
background-repeat:no-repeat;
padding: ${(p) => p.theme.spacing.sm};
margin-bottom:${(p) => p.theme.spacing.xs};
border-radius:${(p) => p.theme.radius.xs};
background-size:cover;
display:flex;
align-items:center;
position:relative;
@media(min-width:1800px){
   padding:${(p) => p.theme.spacing.sm};
 }
`;